export default __webpack_public_path__ + "static/media/img2.938dda39.jpg";